import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { ShopCategoryComponent } from '../shop/shop-category';
import { ComponentRef } from '@opten/compiler/metadata/di';

@Component({ className: 'js-product', observe: true })
export class ProductComponent implements OnInit {
	@ComponentRef(ShopCategoryComponent) basketComponent: ShopCategoryComponent;

	constructor(private element: HTMLElement) {}
	onInit(): void {
		const productVariantQuantities = Array.from(
			this.element.getElementsByClassName(this.basketComponent.options.selectors.productVariantQuantity)
		) as HTMLElement[];
		this.basketComponent.reinitProductVariantQuantities(productVariantQuantities);
	}
}
